import { Textarea } from '@chakra-ui/react'

export default Textarea
